const clearStateFn = () => {
  return {
    keyword: '',
    gender: null,
    dateCreated: '',
    location: null,
    origin: null
  }
}

export default {
  namespaced: true,
  state: clearStateFn(),

  getters: {
    requestQueryParams: state => {
      const params = {}

      if (state.keyword !== '') {
        params.keyword = state.keyword
      }

      if (state.gender !== null) {
        params.gender = state.gender
      }

      if (state.dateCreated !== '') {
        params.dateCreated = state.dateCreated
      }

      if (state.location !== null) {
        params.location = state.location
      }

      if (state.origin !== null) {
        params.origin = state.origin
      }

      return params
    },

    keyword: state => {
      return state.keyword
    },

    gender: state => {
      return state.gender
    },

    dateCreated: state => {
      return state.dateCreated
    },

    location: state => {
      return state.location
    },

    origin: state => {
      return state.origin
    }
  },

  mutations: {
    keyword: (state, payload) => {
      state.keyword = payload
    },

    gender: (state, payload) => {
      state.gender = payload
    },

    dateCreated: (state, payload) => {
      state.dateCreated = payload
    },

    location: (state, payload) => {
      state.location = payload
    },

    origin: (state, payload) => {
      state.origin = payload
    },

    reset: (state) => {
      const clearState = clearStateFn()

      for (let f in clearState) {
        state[f] = clearState[f]
      }
    }
  }
}
